module.exports = __webpack_public_path__ + "static/media/dashboard.ed667da6.svg";